import React from 'react';
import { ControlSuspense } from '../../ControlSuspense';

const Controller = React.lazy(() => import('./Controller'));

export default function TextController(props) {
  return <ControlSuspense children={<Controller {...props} />} skeletonProps={{ height: 5 }} />;
}
